define('views/modals/filter/index',['require','views/base/modal','views/modals/filter/content'],function(require) {
    'use strict';

    var     ModalView = require('views/base/modal'),
        FilterModalContentView = require('views/modals/filter/content');

    var FilterModalView = ModalView.extend({
        listen: {
            'action model': 'handleAction'
        },
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);

            this.subview('content', new FilterModalContentView({ model: this.model.content }));
        },
        saving: function(model, value) {
            console.log('state', value);
        },
        openSaving: function () {
            var buttons = this.$('.modal-footer a');
            var $saveButton = $(buttons[0]);
            var $hideButtons = buttons.not(':first').not(':last');

            var $input = $('<input type="text">')
                .attr('placeholder', 'Название фильтра')
                .addClass('form-control')
                .css({
                    opacity: 0
                });

            this.$('.modal-footer').prepend($input);

            $input.animate({ opacity: 1 });

            $hideButtons
                .css({ opacity: 1 })
                .animate({ opacity: 0 }, function() {
                    $hideButtons.css({ display: 'none' });
                });

            $saveButton
                .css({ position: 'absolute', left: '15px' })
                .animate({ left: '364px' }, function() {
                    $input.focus();
                });
        },
        closeSaving: function(callback) {
            var buttons = this.$('.modal-footer a');
            var $input = this.$('.modal-footer input');
            var $hideButtons = buttons.not(':first').not(':last');
            var $saveButton = $(buttons[0]);

            var $message = this.$('.modal-footer>div');

            $message
                .animate({ 'margin-top': '-15px', 'opacity': 0 }, function() {
                    $message.remove();
                });

            $input
                .animate({ opacity: 0 }, function() {
                    $input.remove();
                });

            $hideButtons
                .css('display', '')
                .animate({ opacity: 1 }, function() {
                });

            $saveButton
                .animate({ left: '15px' }, function() {
                    if (callback) { callback(); }
                });
        },
        closeSaved: function(callback) {
            var buttons = this.$('.modal-footer a');

            var $input = this.$('.modal-footer input');
            var $message = $('<div><i class="icon icon-check-circle-o text-success"></i> Фильтр сохранен</div>');
            var $hideButtons = buttons.not(':first').not(':last');
            var $saveButton = $(buttons[0]);

            $message
                .css({
                    'position': 'absolute',
                    'margin-top': '-15px',
                    'opacity': 0,
                    'font-size': '16px'
                });

            this.$('.modal-footer').prepend($message);

            $saveButton.addClass('disabled');
            $saveButton.prop('disabled', true);

            $input
                .animate({ 'margin-top': '15px', 'opacity': 0 }, function() {
                    $input.remove();
                });

            $message
                .animate({ 'margin-top': '6px', 'opacity': 1 }, function() {
                    setTimeout(function() {
                        $message.animate({ opacity: 0 }, function() {
                            $message.remove();
                        });

                        $hideButtons
                            .css('display', '')
                            .animate({ opacity: 1 }, function() {
                            });

                        $saveButton
                            .animate({ left: '15px' }, function() {
                                $saveButton.removeClass('disabled');
                                $saveButton.prop('disabled', false);
                                if (callback) { callback(); }
                            });
                    }, 1000);
                });
        },
        showInvalidMessage: function(message) {
            var $input = this.$('.modal-footer input');

            var $message = $('<div><i class="icon icon-warning text-error"></i> ' + message + '</div>');
            var $saveButton = this.$('.modal-footer a:first');

            $message
                .css({
                    'position': 'absolute',
                    'margin-top': '-15px',
                    'opacity': 0,
                    'font-size': '16px'
                });

            this.$('.modal-footer').prepend($message);

            $saveButton.addClass('disabled');
            $saveButton.prop('disabled', true);

            $input
                .animate({ 'margin-top': '15px', 'opacity': 0 });

            $message
                .animate({ 'margin-top': '6px', 'opacity': 1 }, function() {
                    setTimeout(function() {
                        $input.animate({ 'margin-top': '0px', 'opacity': 1 });
                        $message.animate({ 'margin-top': '-15px', 'opacity': 0 }, function() {
                            $message.remove();
                            $saveButton.removeClass('disabled');
                            $saveButton.prop('disabled', false);
                        });
                    }, 1000);
                });
        },
        handleAction: function(action, cancel) {
            var model = this.model;

            var savingStage = model.get('savingStage');

            switch (action) {
                case 'save':
                    if (!savingStage) {
                        cancel();
                        model.set('savingStage', 'input-name');
                        this.openSaving();
                    } else {
                        if (savingStage === 'input-name') {
                            cancel();
                            var name = this.$('.modal-footer input').val();
                            if (!name) {
                                this.showInvalidMessage('Введите название фильтра');
                            } else if (name && (name.length > 30)) {
                                this.showInvalidMessage('Слишком длинное название');
                            } else {
                                this.model.trigger('saveFilter', name);
                                this.closeSaved(function() {
                                    model.set('savingStage', null);
                                });
                            }
                        }
                    }

                    break; // save

                case 'cancel':
                    if (savingStage === 'input-name') {
                        cancel();
                        this.closeSaving();
                        model.set('savingStage', null);
                    }
                    break;
            }
        }
    });

    return FilterModalView;
});

